/** * create 2020-06-18 * author huangxu */
<template>
  <div class="bigdata-home ai-home">
    <navBarNoLab :onIndex="4" />
    <!-- 背景部分 -->
    <backGroundCom :backGroundCom="backGroundComInfo">
      <template #navList>
        <pageElement :onIndex="2" />
      </template>
    </backGroundCom>
    <div class="subject" @click="$router.push('/ai-subject')">
      <img src="./aiImg/subject.png" />
    </div>
    <!-- 项目实战全纪录 -->
    <actualCombat :actualCombatData="actualCombatData"></actualCombat>
    <!-- 精选项目 -->
    <selectProject :selectProjectData="selectProjectData"></selectProject>
    <!-- 打造AI真项目 制定AI新标准 -->
    <aiRealProject />
    <!-- 三大硬核标准 制定AI行业新规范 -->
    <industryNorms />
    <!-- 人工智能培养体系 -->
    <system></system>
    <!-- 用心打磨才是好项目 -->
    <goodProject></goodProject>
    <!-- 众多方面部分 -->
    <!-- <aiProfession /> -->
    <bottomWidge />
  </div>
</template>

<script>
import { aiHome } from "../../../../gqlapi/aiHome";
import navBarNoLab from "@/views/components/navBarNoLab";
import backGroundCom from "./components/backGroundCom";
import aiRealProject from "./components/aiRealProject";
// import aiProfession from './components/aiProfession';
import industryNorms from "./components/industryNorms";
import bottomWidge from "@/views/components/bottomWidge";
import actualCombat from "./components/actualCombat";
import selectProject from "./components/selectProject";
import system from "./components/system";
import goodProject from "./components/goodProject";
// 导航抽离
import pageElement from "../common/pageElement";

export default {
  name: "homeAi",
  components: {
    navBarNoLab,
    backGroundCom,
    aiRealProject,
    // aiProfession,
    industryNorms,
    bottomWidge,
    pageElement,
    actualCombat,
    selectProject,
    system,
    goodProject,
  },
  data() {
    return {
      backGroundComInfo: {
        onIndex: 2,
        title1: "人工智能",
        title: "拥抱新基建 开启智能新时代！",
        enTitle:
          "我国人工智能总体技术和应用将与国内外先进水平同步，人工智能领域将成为新的重要经济增长点！",
        projectList: [
          { typeList: "火热", realList: "真项目" },
          { typeList: "众多行业", realList: "助力学员" },
          { typeList: "百度等大厂", realList: "联合共建" },
          { typeList: "技术大牛", realList: "倾心讲授" },
        ],
      },
      actualCombatData: [],
      selectProjectData: [],
    };
  },
  created() {
    this.getList("8");
  },
  methods: {
    getList(ids) {
      // this.$apollo
      //   .query({
      //     query: Contents,
      //     variables: {
      //       subjectID: ids,
      //       isPublish: true,
      //     },
      //   })
      this.$axios
        .post("/api", {
          operationName: "JavaHome",
          variables: {
            subjectID: ids,
            isPublish: true,
          },
          query: aiHome,
        })
        .then((res) => {
          this.actualCombatData =
            res.data.data.javaHome.FirstScreen.contListDataes; // this.itemData = res.data.data.pContents;
          this.selectProjectData =
            res.data.data.javaHome.ThirdScreen.contListDataes;
          console.log(this.actualCombatData, "res");
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-home {
  background-color: #fff;
  min-width: 1466px;
  .subject {
    display: flex;
    margin-top: 70px;
    justify-content: center;
    cursor: pointer;
    img {
      width: 75%;
      max-width: 1440px;
    }
  }
  .topClass {
    position: fixed;
    right: 23px;
    top: 75%;
    background: url("../../../../assets/top.png") no-repeat 50% 50%;
    background-size: 100%;
    display: inline-block;
    width: 50px;
    height: 50px;
    z-index: 999;
    cursor: pointer;
    &:hover {
      background: url("../../../../assets/topon.png") no-repeat 50% 50%;
      background-size: 100%;
    }
  }
}
</style>
